<template>
  <UiAdditionalInformation path="/tilleggsopplysninger/brukerinvolvering">
    <UiCommonsHubspot />
  </UiAdditionalInformation>
</template>
